import tw from "twin.macro";

const Hero = tw.section`relative z-0`;

export default Hero;
